export const TOKEN = sessionStorage.getItem('token');
export const USERNAME = sessionStorage.getItem('username');
export const FIRST_NAME = sessionStorage.getItem('firstName');
export const _ID = sessionStorage.getItem('_id');

// export const BASE_URL = "https://healthspark-api.onrender.com/api";
//  export const BASE_URL = "http://localhost:8000/api";
export const BASE_URL = "https://api.healthspark.org.in/api";

